import varAxios from "../../Comman/axios";
import {UpdateReportTypeSetting,GetRegionListUrl,GetUserListByRegionIdUrl,IsEmailEnabledUrl,getCountryUrl,GenerateMonthlyReportByUserId} from '../../Comman/apiEndPoints';
import swal from 'sweetalert';

export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";
export const Fetch_All_Users_Data = "Fetch_All_Users_Data";
export const User_Data_Success = "User_Data_Success";
export const FETCH_COUNTRY_LIST_DATA = "FETCH_COUNTRY_LIST_DATA";
export const FETCH_REGION_LIST_DATA = "FETCH_REGION_LIST_DATA";

export function notify(message){
        swal({ text : message, icon : 'success' })
}
export function getCountryListFunc() {
    return(dispatch) => {
        
       return varAxios.get(getCountryUrl)
       .then(response => {
           if(response.data.statusCode == 200){
            dispatch(
                fetchCountryListData(response.data.countryList)
                );
           }
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchCountryListData(list) {
    return {
        type: FETCH_COUNTRY_LIST_DATA,
        list
    }
}
export function getUserListByRegionId(formData) {
  return (dispatch) => {
     
      return varAxios.post(GetUserListByRegionIdUrl, formData,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            dispatch(
            fetchUserListByRegionIdData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              userList: response.data.regionUserList
             }));
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function fetchUserListByRegionIdData({errorCode, statusCode, userList}) {
  return {
    type : Fetch_All_Users_Data,
    errorCode,
    statusCode,
    userList
  }
}
export function getAllRegionSettings() {
     let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        this.getUserListByRegionId({RegionId:response.data.regionList[0].ID})
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
  
}
export function IsEmailEnabled(data) {
  return (dispatch) => {
    
      return varAxios.post(IsEmailEnabledUrl,data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
                  UserDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.errorMessage)
              );
              if(response.data.statusCode)
              {
                notify(response.data.errorMessage)
              }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function PerUserPdfMail(data) {
  return (dispatch) => {
    
      return varAxios.post(GenerateMonthlyReportByUserId,data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
                  UserDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.errorMessage)
              );
              if(response.data.statusCode)
              {
                notify(response.data.Message)
              }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function UserDataSuccess(errorCode,statusCode,Message) {
  return{
    type : User_Data_Success,
    errorCode,
    statusCode,
    Message,
  } 
}

export function UpdateReportTypeSettings(data) {
  return (dispatch) => {
    
      return varAxios.post(UpdateReportTypeSetting,data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              
              if(response.data.statusCode)
              {
                notify(response.data.Message)
              }
          })
          .catch((error) => {
              console.log(error)
          })
  }
  
}
export function getAllRegionSettings1() {
     let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}